import { render, staticRenderFns } from "./ConsultationView.vue?vue&type=template&id=17a04e61&scoped=true"
import script from "./ConsultationView.vue?vue&type=script&lang=js"
export * from "./ConsultationView.vue?vue&type=script&lang=js"
import style0 from "./ConsultationView.vue?vue&type=style&index=0&id=17a04e61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a04e61",
  null
  
)

export default component.exports